import { application } from '@core/controllers/app';

application.register('fuso-controllers--customers--payment-method-setup-form', 
  require('./customers/payment_method_setup_form_controller').default);
